import React, { useContext, useState, useRef, useEffect } from 'react'
import { navigate } from 'gatsby'
import ReCAPTCHA from 'react-google-recaptcha'
import * as reCaptchaKey from './../../../shared/constants/reCaptcha'
import { siteUrl } from '../../../shared/utils/siteUrl'
import userSessionStorage from '../../../utils/userSessionStorage'
import { Context } from '../../../context/app-context'
import Button from '../../atoms/button/button'
import getUrlIdRegister from '../../../utils/getUrlIdRegister'
import { textCountry } from './replica-modalLogin'
import { LayoutModal } from '../../templates/layout-modal/layout-modal'
import './modalLogin.scss'
import { triggerTag } from '../../../utils/taggeo'

const LOCALE = process.env.LOCALE
const italatam = LOCALE === 'es-AR' || LOCALE === 'es-PY'
const COUNTRY_PHONE_PREFIX = process.env.COUNTRY_PHONE_PREFIX

const WannaLogin = () => {
  const handlerOnClick = () => {
    triggerTag('11A', { label: textCountry.textLink1 })
  }
  return (
    <div className="f-modalLogin__wannalogin">
      <p>{textCountry.text1}</p>
      <a
        href={siteUrl + getUrlIdRegister()}
        rel="noreferrer"
        target="_blank"
        onClick={handlerOnClick}
      >
        {textCountry.textLink1}
      </a>
      <div className="f-modalLogin__video">
        <iframe
          className="f-modalLogin__video__iframe"
          src="https://www.youtube.com/embed/JZb-gFfmmq0"
          title="YouTube video player"
          //frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          //allowfullscreen
        ></iframe>
      </div>
      <p className="f-textAdi">
        ¡Sophi se encarga de explicarte paso a paso cómo registrarte!
      </p>
    </div>
  )
}
const ModalLogin = ({
  close,
  handleStartGame,
  handleSuccess,
}: {
  close: () => void
  handleStartGame: () => void
  handleSuccess: () => void
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [data, setData] = useState({
    email: '',
    password: '',
  })
  const recaptchaRef = useRef<any>(null)
  const session = new userSessionStorage()
  const { dispatch } = useContext(Context)
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    })
  }

  const handleErrorMessage = (message: string) => {
    setErrorMessage(message)
    setTimeout(() => {
      setErrorMessage('')
    }, 5000)
  }

  const dispatchRedeem = () => {
    dispatch!({
      type: 'set',
      payload: {
        modalActive: {
          type: `redeem`,
          props: {
            handleStartGame,
            close: () => {
              navigate('/')
              dispatch!({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
          },
        },
      },
    })
  }
  const handlerOnClickLink = (evt: any) => {
    triggerTag('11A', { label: evt?.target?.textContent })
  }
  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (isLoading) {
      // PREVENT MULTIPLE CALLS..
      return
    }

    let emailOrPhone = data.email ? data.email.replace(/\s+/g, '') : ''
    if (emailOrPhone === '') {
      // PREVENT EMPTY
      return
    }
    // validate if is only numbers
    if (/^\d+$/.test(emailOrPhone)) {
      emailOrPhone = COUNTRY_PHONE_PREFIX + emailOrPhone
    }
    setIsLoading(true)
    session.authLogin({
      payload: {
        email: emailOrPhone,
        password: data.password,
        captcha: recaptchaRef.current.getValue(),
      },
      handleSuccess: () => {
        session.authUserInfo({
          handleSuccess: () => {
            setIsLoading(false)
            triggerTag('10A', { label: 'Enviar' })
            if (handleSuccess) {
              // reload page
              handleSuccess()
            } else {
              dispatchRedeem()
            }
          },
          handleError: (res: any) => {
            session.destroySession()
            handleErrorMessage(res.userMessage)
            setIsLoading(false)
          },
        })
      },
      handleError: res => {
        handleErrorMessage(res.userMessage)
        setIsLoading(false)
      },
      handleFinally: () => {
        recaptchaRef.current.execute()
      },
    })
  }

  useEffect(() => {
    const tokenInfo = session.getToken()
    if (tokenInfo) {
      const userInfo = session.getUserInfo()
      if (userInfo) {
        dispatchRedeem()
      } else {
        session.authUserInfo({
          handleSuccess: () => {
            dispatchRedeem()
          },
          handleError: () => {
            session.destroySession()
            setIsLoading(() => false)
          },
        })
      }
    } else {
      setIsLoading(() => false)
    }
  }, [])

  return (
    <LayoutModal
      childrenBG={WannaLogin()}
      close={close}
      className="f-modalLogin"
    >
      <>
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={reCaptchaKey.key}
        />
        <h2>{italatam ? 'Iniciá ' : 'Inicia '} sesión</h2>
        <p>
          Si ya estás registrada en Nosotras Online,{' '}
          {italatam ? 'ingresá' : 'ingresa'} tu usuario y contraseña.
        </p>
        <form onSubmit={onSubmit}>
          <label>Usuario: Correo / celular</label>
          <input
            type="text"
            placeholder="correo@email.com"
            id="user"
            name="email"
            onChange={handleInputChange}
          />
          <label>Contraseña</label>
          <input
            type="password"
            placeholder="*********"
            id="password"
            name="password"
            onChange={handleInputChange}
          />
          <a
            href={siteUrl + '/login/recuperar/'}
            className="f-olvide"
            target="_blank"
            onClick={handlerOnClickLink}
          >
            Olvidé mi contraseña
          </a>
          {errorMessage && (
            <span className="f-errorMessage">{errorMessage}</span>
          )}

          <div className="f-modalLogin__buttons">
            <Button title="Enviar" type="submit" loading={isLoading}>
              Iniciar sesión
            </Button>
          </div>
        </form>
      </>
    </LayoutModal>
  )
}

export default ModalLogin
